// extracted by mini-css-extract-plugin
export var tosLink = "_av-0";